<div class="surface-card p-4 shadow-2 border-round">
  <ng-template [ngIf]="isLoadingResults">
    <app-loading></app-loading>
</ng-template>
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
      <div class="flex justify-start md:justify-start">
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroPratica" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICA <b>{{filtroPratica}}</b> DEL <b>BANDO 1</b> IN FASE <i>3</i></span>

        <span *ngIf="!isPresidioTIM && !filterIsSet" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i></span>
        <span *ngIf="!isPresidioTIM && filtroInLavorazione" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> IN LAVORAZIONE</span>

        <span *ngIf="isPresidioTIM"class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> IN CARICO AL PRESIDIO</span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroLotto"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> E LOTTO  <i>{{filtroLotto}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && !filtroLotto && filtroStatoInfratel && !filtroLottoPerFase"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> E STATO <i>{{filtroStatoInfratel}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroStatoInfratel && filtroLottoPerFase"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> E STATO <i>{{filtroStatoInfratel}}</i> E LOTTO  <i>{{filtroLottoPerFase}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroOda"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> E ODA  <i>{{filtroOda}}</i></span>

        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && filtroImpresa && filtroStatoFlowdy" class="text-l font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> DELL'IMPRESA <b>{{ragioneSocialeImpresa}} </b><u>{{filtroStatoFlowdy}}</u></span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && filtroImpresa && !filtroStatoFlowdy" class="text-l font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> DELL'IMPRESA <b>{{ragioneSocialeImpresa}} </b><u>{{filtroStatoFlowdy}}</u></span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && !filtroImpresa && filtroStatoFlowdy && !filtroRegione" class="text-l font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> CON STATO <u>{{filtroStatoFlowdy}}</u></span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && !filtroImpresa && filtroStatoFlowdy && filtroRegione" class="text-l font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 1</b> IN FASE <i>3</i> CON STATO <u>{{filtroStatoFlowdy}}</u> IN <u>{{filtroRegione.toUpperCase()}}</u></span>
         
      </div>
      <div class="flex justify-end md:justify-center">
      </div>
       
      <div class="flex justify-end md:justify-end">
        <button *ngIf="!isPM && !this.isDirigenteFirmaPacchetti && filterIsSet"
          pButton type="button" icon="pi pi-step-backward"
          pTooltip="Torna indietro" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#f0f4ff; color: #4f46e5; border-color: #4f46e5; font-size: 13px;"
          label="Indietro"
          (click)="goBack()" [disabled]="isLoadingResults || isDemo"
        ></button>
        <button *ngIf="!isPM && !this.isImpresa && !isPresidioTIM && !this.isDirigenteFirmaPacchetti"
          pButton type="button" icon="pi pi-file-edit"
          pTooltip="Aggiorna le informazioni di FASE 3" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#b6efe4; color: #1f3445; border-color: #1f3445; font-size: 13px;"
          label="Aggiorna info"
          (click)="importaInformazioni()" [disabled]="isLoadingResults || isDemo"
        ></button>
        <button *ngIf="!isPM && !this.isImpresa && !this.isDirigenteFirmaPacchetti"
          pButton type="button" icon="pi pi-reply"
          pTooltip="Aggiorna gli esiti della consegna ad Infratel" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#fffdea; color: #05542b; border-color: #05542b; font-size: 13px;"
          label="Carica esiti"
          (click)="importaEsitiConsegna()" [disabled]="isLoadingResults || isDemo"
        ></button>
        <button *ngIf="!isPM && praticheFiltrate && praticheFiltrate.length > 0"
          pButton type="button" icon="pi pi-cloud-download"
          pTooltip="Scarica export" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#e3faf8; color: #0e192d; border-color: #3d64b3; font-size: 13px;"
          label="Scarica report"
          (click)="scaricaReportPratiche()" [disabled]="isLoadingResults"
        ></button>
        <button *ngIf="isPresidioSF && pratiche && pratiche.length > 0"
          pButton type="button" icon="pi pi-file-excel"
          pTooltip="Esporta pratiche RESPINTE (CUI e note bocciatura Infratel)" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#ffecd2; color: #8b4513; border-color: #8b4513; font-size: 13px;"
          label="Export respinte"
          (click)="exportPraticheRespinteFase3()" [disabled]="isLoadingResults || isDemo"
        ></button>
      </div>
    </div>
 
 <!--[sortField]="'numero'" [sortOrder]="1"-->
            <div fxFlex="95%" class="mt-2">
                <p-table #praticheDT styleClass="p-datatable-sm" [value]="praticheFiltrate" dataKey="id" [(selection)]="selectedPratica"
                [selectionPageOnly]="true" [rowHover]="true" [rows]="50" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[50,100,200]" responsiveLayout="scroll" [paginator]="true"
                currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                [globalFilterFields]="['cui','codiceInvio','bando','tipoSede','tipoSedeEffettiva','denominazione','regione','comune','codiceMiur','azienda', 'aziendaFase3', 'lotto','numeroOda', 'numeroOdaFase3','statoFlowdyFase3','codiceStatoInfratelFase3']"
                >
                <ng-template pTemplate="caption">
                  <div class="flex align-items-center md:justify-content-between justify-content-between ">
                  
                    <div class="flex justify-start md:justify-start" style="align-items: stretch;">
                      <span class="p-input-icon-left mr-2">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText placeholder="Cerca" (input)="filtraPratiche($event)" [disabled]="isLoadingResults" style="height: 2.5rem;" />
                      </span>
                      <p-multiSelect 
                        *ngIf="!filterIsSet && !isImpresa"
                        styleClass="fieldFilterControl" 
                        [options]="imprese"
                        [showToggleAll]="false"
                        optionLabel="ragioneSociale"
                        optionValue="id"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Impresa"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.impresa"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniTipoSedeBando1"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Tipo sede"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.tipo"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniStatoInfratelFase3"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Stato Infratel"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.statoInfratel"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniStatoFlowdyFase3"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Stato Pratica"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.statoPratica"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniRegioniBando1"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Regione"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.regione"
                      />
                      <button *ngIf="filterIsSet || filterTabellaIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                        style="background-color: #809cd4; border-color:#191a1b; color: #f9f9f9;font-size: 13px;" (click)="removeFilter()"
                        pTooltip="Rimuovi filtro" tooltipPosition="top" 
                      ></button>
                    </div>
                    <div class="flex justify-end md:justify-center">
                    </div>
                    <div class="flex justify-end md:justify-end">
                        <div class="flex align-items-center" *ngIf="!isPM ">
                          <span class=" mr-2 text-900" style="font-size: small;">Mostra completate</span>
                          <p-inputSwitch [(ngModel)]="mostraPraticheCompletate" (ngModelChange)="onMostraCompletatiChange($event)"></p-inputSwitch>
                        </div>
                      </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">Azioni</th>
                    <th *ngIf="!isPresidioTIM" class="text-center font-['Poppins']" style="font-size: 10px; width: 10%;"></th> 
                    <th pSortableColumn="cui" style="font-size: 10px; width: 20%;">
                        CUI
                    </th>
                    <th pSortableColumn="cui" style="font-size: 10px; width: 8%;">
                      CODICE INVIO
                  </th>
                    <th  pSortableColumn="denominazione" style="font-size: 10px; width: 17%;">
                      SCUOLA
                    </th>
                    <th  pSortableColumn="denominazione" style="font-size: 10px; width: 7%;">
                      COMUNE
                    </th>
                    <th *ngIf="!isImpresa" class="text-center font-['Poppins']" style="font-size: 10px;width: 10%;">
                      IMPRESA
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                        LOTTO
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      ODA
                    </th>
                    
                   <!--  <th pSortableColumn="codiceInvio" style="font-size: 10px; width: 5%;">
                      COD. INVIO
                    </th> -->
                    <th  pSortableColumn="tipoSedeEffettiva" class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      TIPO
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                    STATO F2
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                    STATO F3
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;;">
                    STATO PRATICA
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 2%;">
                      LTE
                     </th>
                     <th class="text-center font-['Poppins']" style="font-size: 10px; width: 2%;">
                      CRE
                     </th>
                     <th *ngIf="!isImpresa && !isPresidioTIM && !isDirigenteFirmaPacchetti && !isDirigenteFirmaVerbali" style="font-size: 9px;" class="text-center">
                      MOD. SUBIRU
                     </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      DATA INVIO
                    </th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                      <td class="text-center" style="width: 10px;">
                        <button 
                          pButton type="button" style="color:rgb(39, 128, 15)"
                          icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text" 
                          (click)="openCaricaAzioni($event,row)">
                        </button> 
                      </td>
                     
                       <td *ngIf="!isPresidioTIM" class="text-center" > 
                        <i *ngIf="showInfoFase3Complete(row)"       class="pi pi-server"    style="color:rgb(12, 155, 57);  margin-left: 5px;"                                                          tooltipPosition="top"   pTooltip="Info fase 3 complete"></i>
                        <i *ngIf="showPacchettoNT9Uploaded(row)"    class="pi pi-building"  style="color:rgb(28, 60, 125);  margin-left: 5px; cursor: pointer;"    (click)="scaricaNT9FromFE(row)"      tooltipPosition="top"   pTooltip="Scarica Pacchetto NT9"></i>
                        <i *ngIf="showFotoRouterUploaded(row)"      class="pi pi-camera"    style="color:rgb(10, 101, 97);  margin-left: 5px;cursor: pointer; "    (click)="scaricaFotoRouter(row)"     tooltipPosition="top"   pTooltip="Scarica Foto Router"></i>
<!--                         <i *ngIf="row.wifi && showVerbaleWifiUploaded(row)"     class="pi pi-wifi"    style="color:rgb(10, 101, 97);  margin-left: 5px; cursor: pointer;"     (click)="scaricaVerbaleWifi(row)"       tooltipPosition="top"   pTooltip="Scarica Verbale Wifi"></i>
 -->
                        <i *ngIf="showAltriFileUploaded(row)"       class="pi pi-file"      style="color:rgb(10, 101, 97); margin-left: 5px; cursor: pointer;"     (click)="openScaricaAltriFile(row)"  tooltipPosition="top"   pTooltip="Scarica Altri file "></i>
                        <i *ngIf="showDocs(row)"                    class="pi pi-file-pdf"  style="color:rgb(39, 128, 15);  margin-left: 5px; cursor: pointer;"    (click)="generaDocumentazione(row)"    tooltipPosition="top" pTooltip="Genera documenti"></i>
                        <i *ngIf="isDeliverable(row)"             class="pi pi-send"      style="color:rgb(39, 128, 15); "                                      tooltipPosition="top" pTooltip="Consegnabile"></i>
             
                       <!--  <button *ngIf="checkIfDeliverable(row)"
                          pButton type="button" style="color:rgb(39, 128, 15)"
                          icon="pi pi-send" class="p-button-rounded p-button-text" 
                          (click)="consegnaPratica(row)" pTooltip="Consegna">
                        </button>  -->
                      </td>  
                      <td > 
                        <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 9px; "
                        [pTooltip]="row.codiceMiur"
                        tooltipPosition="top">{{row.cui}}</span> 
                      </td>
                      <td > 
                        <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 8px; "
                        [pTooltip]="row.codiceInvio"
                        tooltipPosition="top">{{row.codiceInvio}}</span> 
                      </td>
                      <td > 
                        <span class="text-uppercase font-['Poppins']" style="font-weight: 500;font-size: 10px; "
                          [pTooltip]="row.indirizzo"
                          tooltipPosition="top"
                          >{{row.denominazione}}</span> 
                      </td>
                      <td > 
                        <span class="text-uppercase font-['Poppins']" style="font-weight: 500;font-size: 10px; "
                        [pTooltip]="row.regione.toUpperCase()"
                          tooltipPosition="top"
                          >{{row.comune.toUpperCase()}}</span> 
                      </td>
                      <td *ngIf="!isImpresa" class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.aziendaFase3?row.aziendaFase3:row.azienda | uppercase"
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '8px',
                                  'letter-spacing': '.2px;',
                                  'cursor': 'pointer',
                                }"
                                 (click)="filtraPerAzienda(row.aziendaFase3?row.aziendaFase3:row.azienda)"
                                 [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per azienda '+ row.aziendaFase3?row.aziendaFase3:row.azienda"
                                  tooltipPosition="top"
                            ></p-tag>
                       </td>
                    
                      <td class="text-center font-['Poppins']"> 
                        <p-tag [value]="row.lotto | uppercase"
                              [style]="{
                                'background-color': '#EBC66B' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '9px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                                  class="mr-1"
                                  (click)="filtraPerLotto(row.lotto)"
                                  [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per lotto '+row.lotto"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.numeroOda || row.numeroOdaFase3" [value]="row.numeroOdaFase3?row.numeroOdaFase3:row.numeroOda"
                              [style]="{
                                'background-color': '#78C0E0' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '10px',
                                'letter-spacing': '.3px;',
                              }"
                                  class="mr-1"
                                  
                        ></p-tag>
                      </td>
                     
                    
                      <td *ngIf="row.tipoSede === row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 10px;">{{getTipoSedeAbbreviata(row.tipoSede)}}</span> </td>
                      <td *ngIf="row.tipoSede !== row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 10px;">{{getTipoSedeAbbreviata(row.tipoSede)}} ({{getTipoSedeAbbreviata(row.tipoSedeEffettiva)}})</span> </td>
 
                       <td class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.codiceStatoInfratelFase2 | uppercase"
                                [style]="{
                                  'background-color': stiliService.getStatoInfratelColor(row.codiceStatoInfratelFase2) ,
                                  'color': '#000000' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '10px',
                                  'letter-spacing': '.3px;',
                                  'cursor': 'pointer',
                                }"
                                [pTooltip]="utilService.formattaDataDaTimestampFirestore(row.dataRispostaInfratelFase2)"
                                tooltipPosition="top"
                                
                            ></p-tag>
                       </td> 
                       
                       <td class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.codiceStatoInfratelFase3 | uppercase"
                                [style]="{
                                  'background-color': stiliService.getStatoInfratelColor(row.codiceStatoInfratelFase3) ,
                                  'color': '#000000' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '10px',
                                  'letter-spacing': '.3px;',
                                  
                                }"
                                
                            ></p-tag>
                       </td>
                       <td class="text-center font-['Poppins']"> 

                        <span 
                          class="material-symbols-outlined "
                          [ngClass]="stiliService.getMaterialIconStatoFlowdy(row.statoFlowdyFase3, 1)"
                          [ngStyle]="{ 
                             'color': stiliService.getColoreIconaStatoFlowdyFase3(row) 
                             }"
                          [pTooltip]="!simpleCheckLavorabilitaFase3(row) ? row.statoFlowdyFase3 + '\n (info mancanti)' : row.statoFlowdyFase3" 

                          tooltipPosition="top">
                          {{ stiliService.getMaterialIconStatoFlowdy(row.statoFlowdyFase3, 1) }}
                        </span>
                       </td>
                      
                       <td class="text-center font-['Poppins']">
                        <i class="pi"
                        [ngClass]="{ 'text-green-800 pi-check': row.backup}"></i>
                      </td> 
                     
                      <td class="text-center font-['Poppins']">
                        <span *ngIf="row.cre" 
                          class="material-symbols-outlined" pTooltip="Scarica CRE" tooltipPosition="top"
                          [style]="{
                            'cursor': 'pointer',
                            'color': '#000000' ,
                          }"
                          > 
                          {{'arrow_circle_down'}}
                        </span>
                      </td> 
                      <td *ngIf="!isImpresa && !isDirigenteFirmaVerbali && !isDirigenteFirmaPacchetti && !isPresidioTIM" class="text-center">
                        <i *ngIf="row.usaVecchioModelloSUBIRU" class="pi pi-angle-double-left text-text-blue-700"  tooltipPosition="top" pTooltip="Pratica che usa vecchio modello SUBIRU"></i>
                      </td>
                    
                     
                      <td class="text-center font-['Poppins']">
                         <span *ngIf="row.dataRispostaInfratelFase3 && row.codiceStatoInfratelFase3==='3-6'" class="text-center text-uppercase font-semibold font-['Poppins']" style="font-size: 11px; ">{{utilService.formattaDataDaTimestampFirestore(row.dataRispostaInfratelFase3)}}</span>
                        <span *ngIf="row.dataInvioInfratelFase3 && row.codiceStatoInfratelFase3!=='3-6'" class="text-center text-uppercase font-semibold font-['Poppins']" style="font-size: 11px; ">{{utilService.formattaDataDaTimestampFirestore(row.dataInvioInfratelFase3)}}</span>
                      </td> 
                      </tr>
                </ng-template>
              </p-table> 
              <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>
            </div>
		</div>

    <p-dialog [(visible)]="showIniziaProgettazione" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [closable]="false" [showHeader]="false">
      <div class="flex flex-column align-items-center my-4">
         <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
             <i class="material-symbols-outlined small-icon" >tactic</i>
         </span>
         <div class="font-medium text-2xl text-900">PROGETTAZIONE</div>
     </div>
     <p class="line-height-3 p-0 m-0 ">
        Confermi di voler iniziare la progettazione della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
     </p>
     <ng-template pTemplate="footer">
         <div class=" border-top-1 surface-border pt-3 flex">
             <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showIniziaProgettazione = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
             <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaInizioProgettazione()" label="CONFERMA" class="w-6 ml-2"></button>
         </div>
     </ng-template>
    </p-dialog>  

    <p-dialog [(visible)]="showGeneraDocumentazione" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [closable]="false" [showHeader]="false">
      <div class="flex flex-column align-items-center my-4">
         <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
             <i class="material-symbols-outlined small-icon" >file_save</i>
         </span>
         <div class="font-medium text-2xl text-900">DOCUMENTAZIONE</div>
     </div>
     <p class="line-height-3 p-0 m-0 ">
        Confermi di voler generare e scaricare la documentazione di FASE 3 della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
     </p>
     <ng-template pTemplate="footer">
         <div class=" border-top-1 surface-border pt-3 flex">
             <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showGeneraDocumentazione = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
             <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaGenerazioneDocumentazione()" label="CONFERMA" class="w-6 ml-2"></button>
         </div>
     </ng-template>
    </p-dialog>  

 <p-dialog [(visible)]="showDeliverConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [closable]="false" [showHeader]="false">
     <div class="flex flex-column align-items-center my-4">
        <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 border-circle mb-3" style="width:64px;height:64px">
            <i class="pi pi-send text-5xl"></i>
        </span>
        <div class="font-medium text-2xl text-900">CONSEGNA</div>
    </div>
    <p class="line-height-3 p-0 m-0">
       Confermi di voler consegnare la <strong>FASE 3</strong> della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
    </p>
    <ng-template pTemplate="footer">
        <div class=" border-top-1 surface-border pt-3 flex">
            <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDeliverConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
            <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaConsegnaPratica()" label="CONFERMA" class="w-6 ml-2"></button>
        </div>
    </ng-template>
</p-dialog>  

<p-dialog [(visible)]="showAnnullaConsegnaConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-orange-100 text-orange-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-send text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ANNULLA CONSEGNA</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler annullare la consegna della FASE 3 pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showAnnullaConsegnaConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaAnnullamentoConsegnaPratica()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showEliminaFileALTROConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-eraser text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE FILE</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare tutti i file di tipo ALTRO della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaFileALTROConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="eliminataTuttiFileCaricati(selectedPratica, 'ALTRO')" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showEliminaFileNT9Confirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-eraser text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE PACCHETTO NT9</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare il pacchetto NT9 della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaFileNT9Confirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="eliminataTuttiFileCaricati(selectedPratica, 'NT9')" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showEliminaFileFotoRouterConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-eraser text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE FOTO ROUTER</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare la foto router della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaFileFotoRouterConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="eliminataTuttiFileCaricati(selectedPratica, 'FOTO ROUTER')" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>
<p-dialog [(visible)]="showEliminaFileVerbaleWifiConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-eraser text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE VERBALE WIFI</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare il verbale wifi della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaFileVerbaleWifiConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="eliminataTuttiFileCaricati(selectedPratica, 'VERBALE WIFI')" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showResettaPratica" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '60vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-orange-100 text-orange\-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="material-symbols-outlined small-icon" >reset_settings</i>
     </span>
     <div class="font-medium text-2xl text-900">RESET PRATICA</div>
 </div>
 <p class="line-height-3 p-0 m-0 ">
    Confermi di voler <u>RESETTARE</u> la <b>FASE 3</b> della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showResettaPratica = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaResetPratica()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>  

<p-dialog [(visible)]="showFase1Approvata" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="material-symbols-outlined small-icon" >verified</i>
     </span>
     <div class="font-medium text-2xl text-900">FASE 1 APPROVATA</div>
 </div>
 <p class="line-height-3 p-0 m-0 ">
    Confermi di voler comunicare l'approvazione  della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span> da parte di INFRATEL?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showFase1Approvata = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaApprovazioneFase1()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>  


<p-toast position="top-center"></p-toast>
<p-confirmDialog></p-confirmDialog>